import produce from "immer";
import { createContext, FC, useCallback, useState } from "react";
import { VerificationDTO } from "../../../../../store/verification/models/dto/due-diligence";
import { DueDiligenceFileCategory } from "../../../../../store/verification/models/internal";

interface AttachmentContext {
  company: {
    files: Partial<
      Record<
        typeof DueDiligenceFileCategory.T,
        VerificationDTO.Requests.DueDiligence.Form.Post.Attachments.T
      >
    >;
    setFile: (
      type: typeof DueDiligenceFileCategory.T,
      file: VerificationDTO.Requests.DueDiligence.Form.Post.Attachments.T
    ) => void;
  };
  kycs: {
    files: Array<
      Partial<
        Record<
          typeof DueDiligenceFileCategory.T,
          VerificationDTO.Requests.DueDiligence.Form.Post.Attachments.T
        >
      >
    >;
    setFile: (
      type: typeof DueDiligenceFileCategory.T,
      file: VerificationDTO.Requests.DueDiligence.Form.Post.Attachments.T,
      index: number
    ) => void;
  };
}

export const AttachmentContext = createContext(
  (undefined as any) as AttachmentContext
);

export const AttachmentContextProvider: FC<{}> = ({ children }) => {
  const [companyFiles, setCompanyFiles] = useState<
    AttachmentContext["company"]["files"]
  >({});

  const [kycFiles, setKycFiles] = useState<AttachmentContext["kycs"]["files"]>(
    []
  );

  const setCompanyFile = useCallback(
    (type: typeof DueDiligenceFileCategory.T, file: any) => {
      setCompanyFiles(
        produce((x) => {
          x[type] = file;
        })
      );
    },
    [setCompanyFiles]
  );

  const setKycFile = useCallback(
    (type: typeof DueDiligenceFileCategory.T, file: any, index: number) => {
      setKycFiles(
        produce((arr) => {
          if (arr[index] === undefined) arr[index] = {};
          arr[index][type] = file;
        })
      );
    },
    [setKycFiles]
  );

  return (
    <AttachmentContext.Provider
      value={{
        company: {
          files: companyFiles,
          setFile: setCompanyFile,
        },
        kycs: {
          files: kycFiles,
          setFile: setKycFile,
        },
      }}
    >
      {children}
    </AttachmentContext.Provider>
  );
};
